import { AnnouncementBaseSlideShowPanel } from "./AnnouncementStreamTypesSlideShowPanel";
import { Env } from "../../../settings/Env";
import { Settings } from "../../../settings/Settings";
export class AnnouncementStreamTypesSlideShowPanel extends AnnouncementBaseSlideShowPanel {
    _getSlideLayouts(_slidesCount) {
        return Env.lobby.announcementStreamTypes.slides;
    }
    _beforeClose() {
        Settings.getInstance().streamTypesAnnouncement.wasViewed = true;
    }
}
// export class AnnouncementFavoritesSlideShowPanel extends AnnouncementBaseSlideShowPanel {
//     protected _getSlideLayouts(_slidesCount: number): AnnouncementSlideLayout[] {
//         return Env.lobby.announcementFavorites.slides;
//     }
//
//     protected _beforeClose() {
//         Settings.getInstance().favoritesAnnouncement.wasViewed = true;
//     }
// }
// export class AnnouncementRelatedBroadcastsSlideShowPanel extends AnnouncementBaseSlideShowPanel {
//     protected _getSlideLayouts(_slidesCount: number): AnnouncementSlideLayout[] {
//         return Env.lobby.announcementRelatedBroadcasts.slides;
//     }
//
//     protected _beforeClose() {
//         Settings.getInstance().relatedBroadcastsAnnouncement.wasViewed = true;
//     }
// }
// export class AnnouncementVodSlideShowPanel extends AnnouncementBaseSlideShowPanel {
//     protected _getSlideLayouts(_slidesCount: number): AnnouncementSlideLayout[] {
//         return Env.lobby.announcementVod.slides;
//     }
//
//     protected _beforeClose() {
//         Settings.getInstance().vodAnnouncement.wasViewed = true;
//     }
// }
// export class AnnouncementMessengerSlideShowPanel extends AnnouncementBaseSlideShowPanel {
//     protected _getSlideLayouts(_slidesCount: number): AnnouncementSlideLayout[] {
//         return Env.lobby.announcementMessenger.slides;
//     }
//
//     protected _beforeClose() {
//         Settings.getInstance().messengerAnnouncement.wasViewed = true;
//     }
// }
export class AnnouncementPtSlideShowPanel extends AnnouncementBaseSlideShowPanel {
    _getSlideLayouts(_slidesCount) {
        return Env.lobby.announcementPt.slides;
    }
    _beforeClose() {
        Settings.getInstance().ptAnnouncement.wasViewed = true;
    }
}
